import { render, staticRenderFns } from "./epb-title-input.component.vue?vue&type=template&id=52aa102e&scoped=true"
import script from "./epb-title-input.component.vue?vue&type=script&lang=ts"
export * from "./epb-title-input.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-title-input.component.vue?vue&type=style&index=0&id=52aa102e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa102e",
  null
  
)

export default component.exports